export default "/images/umbrella.svg?b9c9e1198e77e8f4198855b13bb3b64f";